/* eslint-disable import/no-unresolved */
import dayjs from "dayjs";
import { handelIndianCurrencyChange, onChangeIndianCurrency } from "src/helpers/FormDetails";
import CovidDetailsTogglebutton from "src/shared/CovidDetailsToggleButton";
import CustomDatePicker from "src/shared/CustomDatePicker";
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
  dob: string;
}

function InsuranceDetails({ formik, dob }: Props) {
  return (
    <div>
      <div className="flex justify-between">
        <p className="text-daintree font-montserrat text-sm font-medium mb-6">
          Do you have any other insurance policy outside India? If Yes please provide detail.
        </p>
        <CovidDetailsTogglebutton
          isEnabled
          toggleState={formik.values.policyDetails?.isOtherPolicyOutsideIndia}
          fieldObj="policyDetails"
          fieldName="isOtherPolicyOutsideIndia"
          setFieldValue={formik.setFieldValue}
        />
      </div>
      {formik.values?.policyDetails?.isOtherPolicyOutsideIndia && (
        <div>
          <div className="flex flex-col md:flex-row justify-between">
            <div className="w-full md:w-222/1000 mb-6 md:mb-0">
              <CustomTextField
                requiredStar
                label="Insurer Name"
                className=""
                // onChange={handleChange("policyDetails.insurerName")}
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.policyDetails?.insurerName}
                name="policyDetails.insurerName"
                error={formik.errors.policyDetails?.insurerName}
                touched={formik.touched.policyDetails?.insurerName}
              />
            </div>
            <div className="w-full md:w-222/1000 mb-6 md:mb-0">
              <CustomTextField
                requiredStar
                label="Sum Assured"
                className=""
                // onChange={handleChange("policyDetails.sumAssured")}
                onChange={(event) => handelIndianCurrencyChange(event, formik)}
                handleBlur={formik.handleBlur}
                value={onChangeIndianCurrency(formik.values.policyDetails?.sumAssured)}
                name="policyDetails.sumAssured"
                error={formik.errors.policyDetails?.sumAssured}
                touched={formik.touched.policyDetails?.sumAssured}
              />
            </div>
            <div className="w-full md:w-222/1000 mb-6 md:mb-0">
              <CustomTextField
                requiredStar
                label="Premium Amount"
                className=""
                // onChange={handleChange("policyDetails.premiumAccount")}
                onChange={(event) => handelIndianCurrencyChange(event, formik)}
                handleBlur={formik.handleBlur}
                value={onChangeIndianCurrency(formik.values.policyDetails?.premiumAccount)}
                name="policyDetails.premiumAccount"
                error={formik.errors.policyDetails?.premiumAccount}
                touched={formik.touched.policyDetails?.premiumAccount}
              />
            </div>
            <div className="w-full md:w-222/1000 mb-6 md:mb-0">
              <CustomTextField
                requiredStar
                label="Policy Status"
                className=""
                // onChange={handleChange("policyDetails.policyStatus")}
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.policyDetails?.policyStatus}
                name="policyDetails.policyStatus"
                error={formik.errors.policyDetails?.policyStatus}
                touched={formik.touched.policyDetails?.policyStatus}
              />
            </div>
          </div>
          <div className="w-full md:w-222/1000 mr-auto mt-6">
            <CustomDatePicker
              requiredStar
              disableFuture
              minDate={dayjs(new Date(dob.split("/").reverse().join("-")))}
              value={formik.values.policyDetails?.dateOfInsurance}
              label="Date Of Insurance"
              setFieldValue={formik.setFieldValue}
              name="policyDetails.dateOfInsurance"
              error={formik.errors.policyDetails?.dateOfInsurance}
              touched={formik.touched.policyDetails?.dateOfInsurance}
              setFieldTouched={formik.setFieldTouched}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default InsuranceDetails;
